import gql from 'graphql-tag'
export default gql`
query getUserWalletBalance($userId: String!){
    getUserWalletBalance(userId: $userId){
      id
    siteId
    balance
    currency
    createdAt
    }
  }
  `